import { maxLength, notEmpty } from "../validation/validation-helper";
import { MailTemplate } from "./default-mail-cfg-entity";
import { ProcedureEntity } from "@graffer-inc/cloud-gov-core";
import { BaseEntity } from "../base/base-entity";

export type ProcedureMailCfgType = {
  readonly procedureId: string;
  readonly recievedTemplate?: MailTemplate;
  readonly rejectedTemplate?: MailTemplate;
  readonly withdrawnTemplate?: MailTemplate;
  readonly completedTemplate?: MailTemplate;
};

export class ProcedureMailCfg extends BaseEntity {
  public readonly procedureId: string;
  public readonly recievedTemplate?: MailTemplate;
  public readonly rejectedTemplate?: MailTemplate;
  public readonly withdrawnTemplate?: MailTemplate;
  public readonly completedTemplate?: MailTemplate;

  constructor(base: ProcedureMailCfgType) {
    super();
    this.procedureId = base.procedureId;
    this.recievedTemplate = base.recievedTemplate;
    this.rejectedTemplate = base.rejectedTemplate;
    this.withdrawnTemplate = base.withdrawnTemplate;
    this.completedTemplate = base.completedTemplate;
  }

  isValid() {
    return ![
      this.recievedTemplate,
      this.rejectedTemplate,
      this.withdrawnTemplate,
      this.completedTemplate,
    ].find((v) => {
      return !!v && !MailTemplateValidator.checkValid(v);
    });
  }

  static newFrom(proc: ProcedureEntity): ProcedureMailCfg {
    return new ProcedureMailCfg({
      procedureId: proc.id,
    });
  }

  static fromJSON(json: ProcedureMailCfgType): ProcedureMailCfg {
    return new ProcedureMailCfg(json);
  }
}

export const ProcedureMailCfgConst = {
  MAX_TITLE_LENGTH: 100,
  MAX_BODY_LENGTH: 2000,
};

export const MailTemplateValidator = {
  checkValid: (template: MailTemplate) => {
    return (
      !MailTemplateValidator.validateTitle(template.title) &&
      !MailTemplateValidator.validateBody(template.body)
    );
  },
  validateTitle: (title: string) => {
    return (
      notEmpty(title) ||
      maxLength(ProcedureMailCfgConst.MAX_TITLE_LENGTH)(title)
    );
  },
  validateBody: (body: string) => {
    return (
      notEmpty(body) || maxLength(ProcedureMailCfgConst.MAX_BODY_LENGTH)(body)
    );
  },
};
